(function () {
  'use strict';

  if (window.__HK_QM_PREMIUM_INIT__) return;
  window.__HK_QM_PREMIUM_INIT__ = true;

  const MOBILE_BP = 990;

  function isMobile() { return window.innerWidth < MOBILE_BP; }
  function isHover() { return !window.matchMedia('(pointer: coarse)').matches; }

  function allMenus() {
    return Array.from(document.querySelectorAll('details.hk-qm[data-hk-qm]'));
  }

  function closeMenu(menu) {
    if (!menu || !menu.hasAttribute('open')) return;
    menu.removeAttribute('open');
    menu.querySelector('summary')?.setAttribute('aria-expanded', 'false');
  }

  function closeAll(except) {
    allMenus().forEach(menu => {
      if (menu !== except) closeMenu(menu);
    });
  }

  function positionPanel(menu) {
    if (!menu || isMobile()) return;

    const panel = menu.querySelector('.hk-qm__panel');
    const summary = menu.querySelector('summary');
    if (!panel || !summary) return;

    const btn = summary.getBoundingClientRect();
    /* keep the panel inside the header's content box, not the window (UX-045: at 1920 it ran to 1908 px,
       past the 1905 px document and the header's right edge); a panel wider than that box is narrowed to it */
    const header = menu.closest('header') || document.querySelector('header.header');
    const hb = header ? header.getBoundingClientRect() : { left: 0, right: document.documentElement.clientWidth };
    const hcs = header ? getComputedStyle(header) : null;
    const boxLeft = hb.left + (hcs ? parseFloat(hcs.paddingLeft) || 0 : 0);
    const boxRight = Math.min(hb.right - (hcs ? parseFloat(hcs.paddingRight) || 0 : 0), document.documentElement.clientWidth);
    panel.style.maxWidth = Math.max(0, Math.floor(boxRight - boxLeft)) + "px";

    panel.style.top = `${Math.round(btn.bottom + 10)}px`;
    panel.style.left = '0px';
    panel.style.right = 'auto';

    requestAnimationFrame(() => {
      const pw = panel.offsetWidth;
      let left = btn.left;

      /*
        Premium behavior:
        - Service opens from its nav tab.
        - Wider menus never overflow viewport.
      */
      if (left + pw > boxRight) left = boxRight - pw;
      left = Math.max(boxLeft, left);

      panel.style.left = `${Math.round(left)}px`;
    });
  }

  document.addEventListener('toggle', function (event) {
    const menu = event.target;
    if (!menu?.classList?.contains('hk-qm')) return;

    if (menu.hasAttribute('open')) {
      closeAll(menu);
      menu.querySelector('summary')?.setAttribute('aria-expanded', 'true');
      positionPanel(menu);
    }
  }, true);

  document.addEventListener('click', function (event) {
    const overlay = event.target.closest?.('.hk-qm__overlay');
    if (overlay) {
      closeMenu(overlay.closest('details.hk-qm'));
      return;
    }

    const open = document.querySelector('details.hk-qm[open]');
    if (!open || open.contains(event.target)) return;
    closeAll();
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;

    const open = document.querySelector('details.hk-qm[open]');
    if (!open) return;

    closeAll();
    open.querySelector('summary')?.focus();
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Tab') return;

    const open = document.querySelector('details.hk-qm[open]');
    if (!open) return;

    const els = Array.from(open.querySelectorAll(
      'summary, a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])'
    )).filter(el => !el.hasAttribute('disabled') && el.offsetParent !== null);

    if (!els.length) return;

    const first = els[0];
    const last = els[els.length - 1];

    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  });

  function bindHover() {
    allMenus().forEach(menu => {
      if (menu.dataset.hkPremiumBound) return;
      menu.dataset.hkPremiumBound = '1';

      let timer = null;
      let inside = false;

      const openMenu = () => {
        if (isMobile() || !isHover()) return;
        clearTimeout(timer);
        inside = true;

        timer = setTimeout(() => {
          if (!inside) return;
          closeAll(menu);
          menu.setAttribute('open', '');
          menu.querySelector('summary')?.setAttribute('aria-expanded', 'true');
          positionPanel(menu);
        }, 150); /* hover intent, as the catalog (UX-045) */
      };

      const closeDelayed = () => {
        if (isMobile() || !isHover()) return;
        clearTimeout(timer);
        inside = false;

        timer = setTimeout(() => {
          if (!inside) closeMenu(menu);
        }, 155);
      };

      const stay = () => {
        clearTimeout(timer);
        inside = true;
      };

      menu.addEventListener('mouseenter', openMenu);
      menu.addEventListener('mouseleave', closeDelayed);

      const panel = menu.querySelector('.hk-qm__panel');
      if (panel) {
        panel.addEventListener('mouseenter', stay);
        panel.addEventListener('mouseleave', closeDelayed);
      }
    });
  }

  let resizeTimer;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(() => {
      const open = document.querySelector('details.hk-qm[open]');
      if (open) positionPanel(open);
    }, 80);
  }, { passive: true });

  const ready = fn => {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn, { once: true });
    } else {
      fn();
    }
  };

  ready(bindHover);
  /* The menus live in the header section: a theme-editor re-render is the only time new ones appear.
     (Was a page-lifetime MutationObserver on <body> plus a beforeunload listener, which also kept
     Firefox from using the back/forward cache.) */
  document.addEventListener('shopify:section:load', bindHover);
})();
